import { RouterModule } from "@angular/router";

export const routing = RouterModule.forChild([]);
